import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formAuditApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_PROCUREMENT_SUPPLIERS_AUDIT =
  "CREATE_PROCUREMENT_SUPPLIERS_AUDIT";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const createProcurementSuppliersAudit = async (): Promise<void> => {
  const response = await formAuditApi.formAuditControllerCreateSuppliersFormAudit();

  return response.data;
};

export const useCreateProcurementSuppliersAudit = (
  user: UserProfileDto | null,
): {
  createProcurementSuppliersAudit: UseMutateFunction<void, Error, void, unknown>;
  createProcurementSuppliersAuditEnabled: boolean;
  isSuccessCreateProcurementSuppliersAudit: boolean;
  isPendingCreateProcurementSuppliersAudit: boolean;
  isErrorCreateProcurementSuppliersAudit: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending, isError } = useMutation({
    mutationKey: [DOMAIN_FORMS, ACTION_CREATE_PROCUREMENT_SUPPLIERS_AUDIT],
    mutationFn: enabled ? createProcurementSuppliersAudit : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORMS] });
    },
  });

  return {
    createProcurementSuppliersAudit: mutate,
    createProcurementSuppliersAuditEnabled: enabled,
    isSuccessCreateProcurementSuppliersAudit: isSuccess,
    isPendingCreateProcurementSuppliersAudit: isPending,
    isErrorCreateProcurementSuppliersAudit: isError,
  };
};
